module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-D01_r3-clean-0bc2b5dafaa6982259f252ab70dad08d.png";